module.exports = __webpack_public_path__ + "static/media/vaga.9cfbbfb4.svg";